import { Controller } from "@hotwired/stimulus";

export default  class extends Controller {
  static targets = [ "limitQty", "limitAddToCartCheckbox" ]

  connect() {
    this.toggleLimitQtyField();
  }

  toggleLimitQtyField() {
    if (this.limitAddToCartCheckboxTarget.checked) {
      this.limitQtyTarget.classList.remove("d-none");
    } else {
      this.limitQtyTarget.classList.add("d-none");
    }
  }
}
